import { TenancyDetailsBase } from 'src/lib/fliko/models/agreements/tenancyAgr.data';
import { RentalUnit, RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { UnitCode } from 'src/lib/fliko/models/units/unitCode';
import { UserCreationState } from 'src/lib/fliko/models/users/createdUser.data';
import { RentalUnitVM } from 'src/app/view/users/services/models/users-view-models';

export class UserHelper {
  // ? Superadmin only
  public static createUserStateHumanReadable(type: UserCreationState) {
    switch (type) {
      case UserCreationState.CREATED:
        return 'Utworzone zapytanie do bazy';
      case UserCreationState.DELETED:
        return 'Usunięty';
      case UserCreationState.ERRORED:
        return 'Błędny';
      case UserCreationState.SAVED:
        return 'Zapisany w bazie';
    }
  }

  public static unitToRentalUnitVM(unit: RentalUnit, type: RentalUnitType, details?: TenancyDetailsBase): RentalUnitVM {
    return {
      id: unit.id,
      unit,
      type,
      tenancyDetails: { ...details, unitId: unit.id, type },
      unitCode: UnitCode.fromRentalUnit(unit)
    };
  }
}
